import type { MouseEvent } from 'react';

type SidebarResizeHandleProps = {
  onResizeStart: (event: MouseEvent) => void;
};

export function SidebarResizeHandle({ onResizeStart }: SidebarResizeHandleProps) {
  return (
    <button
      type="button"
      aria-label="Redimensionar menu"
      title="Arrastar para redimensionar"
      onMouseDown={onResizeStart}
      className="absolute inset-y-0 right-0 z-10 w-1.5 cursor-col-resize border-0 bg-transparent p-0 hover:bg-white/25 focus:outline-none focus-visible:bg-white/30"
    />
  );
}
